export interface ProductAdditionalProductCost {
  id: string;
  productId: string;
  productKey: string;
  productDescription: string;
  productTypeAdditionalProductCostId: string;
  productTypeAdditionalProductCostKey: string;
  productTypeAdditionalProductCostDescription: string;
  additionalCost: number;
  notes: string;
}
